import { render, staticRenderFns } from "./SalesSuppliers.vue?vue&type=template&id=775c8c1d&scoped=true&"
import script from "./SalesSuppliers.vue?vue&type=script&lang=js&"
export * from "./SalesSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./SalesSuppliers.vue?vue&type=style&index=0&id=775c8c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775c8c1d",
  null
  
)

export default component.exports